/*
 * Lazily loads Shopify's product recommendations for the "Related services"
 * section. Only runs when the section did not already render products from a
 * hand-picked collection.
 */
(function () {
  'use strict';

  function load(section) {
    var url = section.getAttribute('data-url');
    if (!url) return;

    fetch(url)
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var fresh = new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector('[data-pp-recommendations]');
        if (!fresh) return;

        section.innerHTML = fresh.innerHTML;
        section.setAttribute('data-loaded', 'true');

        if (window.PPTheme && typeof window.PPTheme.refresh === 'function') {
          window.PPTheme.refresh();
        }
      })
      .catch(function () {
        section.setAttribute('data-loaded', 'true');
      });
  }

  function init() {
    Array.prototype.forEach.call(
      document.querySelectorAll('[data-pp-recommendations][data-loaded="false"]'),
      function (section) {
        if (!('IntersectionObserver' in window)) {
          load(section);
          return;
        }

        var observer = new IntersectionObserver(
          function (entries) {
            if (!entries[0].isIntersecting) return;
            observer.disconnect();
            load(section);
          },
          { rootMargin: '300px 0px' }
        );

        observer.observe(section);
      }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
